import React from 'react'
import './style.css'

function OpsiLapor(setLapor) {
    return (
        <div className='container-lapor'>
            <div className='opsi-pelaporan'>
                <h2>Pelaporan</h2>
            </div>
        </div>
    )
}

export default OpsiLapor



// WEBPACK FOOTER //
// ./src/pages/Components/Opsi-Lapor/Pelaporan.js